module.exports = __webpack_public_path__ + "img/visa.fbf2bfb0.png";